// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.manage-rewards-container {
  max-width: 1800px;
  margin: 20px;
  padding: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.page-title {
  color: #103f5f;
  text-align: center;
  margin-bottom: 30px;
  font-size: clamp(1.5rem, 2.5vw, 2rem); /* Responsive font size */
  font-weight: bold;
  font-size: 30px;
}

/* Content Layout */
.rewards-content {
  display: flex;
  gap: 30px;
  align-items: flex-start;
}

/* Form Section */
.rewards-form {
  flex: 0 1 450px; /* Flexible but max 450px */
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  height: -moz-fit-content;
  height: fit-content;
}

/* Rewards List Section */
.rewards-list {
  flex: 1 1;
  min-width: 0; /* Fixes flex overflow issues */
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-height: 88vh;
  overflow-y: auto;
}

.rewards-form h3, 
.rewards-list h3 {
  color: #3498db;
  margin-top: 0;
  margin-bottom: 20px;
  font-size: clamp(1.1rem, 1.5vw, 1.3rem);
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

/* Form Styles */
.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
  color: #555;
  font-size: clamp(0.9rem, 1.1vw, 1rem);
}

.form-group input[type="text"],
.form-group input[type="number"],
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 12px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: clamp(0.9rem, 1.1vw, 1rem);
  transition: border-color 0.3s;
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.form-row {
  display: flex;
  gap: 15px;
}

/* File Upload */
.file-upload {
  margin-bottom: 10px;
}
.cancel-btn {
    background-color: #e74c3c;
    color: white;
  }
  
  .cancel-btn:hover {
    background-color: #c0392b;
  }

.upload-btn {
  display: inline-block;
  padding: 12px 15px;
  background: #f8f9fa;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-size: clamp(0.9rem, 1.1vw, 1rem);
}

.image-preview img {
  max-width: 100%;
  max-height: 150px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

/* Form Actions */
.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.submit-btn, .cancel-btn {
  padding: 12px 20px;
  font-size: clamp(0.9rem, 1.1vw, 1rem);
}

/* Table Styles */
.table-container {
  overflow-x: auto;
  max-height: calc(88vh - 100px);
}

table {
  width: 100%;
  min-width: 600px; /* Minimum table width */
}
th {
    background-color: #3498db;
    color: white;
    font-weight: 600;
  }
tr:hover {
    background-color: #f5f5f5;
  } 

th, td {
  padding: 12px;
  font-size: clamp(0.85rem, 1vw, 0.95rem);
  
}

.reward-img {
  width: 50px;
  height: 50px;
}

/* Action Buttons */
.edit-btn, .delete-btn {
  padding: 6px 12px;
  font-size: clamp(0.8rem, 1vw, 0.9rem);
  margin-right: 5px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
}
.edit-btn {
    background-color: #2ecc71;
    color: white;
  }
  
  .edit-btn:hover {
    background-color: #27ae60;
  }
  
  .delete-btn {
    background-color: #e74c3c;
    color: white;
  }
  
  .delete-btn:hover {
    background-color: #c0392b;
  }

/* Responsive Breakpoints */
@media (max-width: 1200px) {
  .rewards-content {
    gap: 20px;
  }
  
  .rewards-form {
    flex-basis: 400px;
  }
}

@media (max-width: 992px) {
  .rewards-content {
    flex-direction: column;
  }
  
  .rewards-form {
    flex-basis: auto;
    width: 100%;
  }
  
  .rewards-list {
    width: 100%;
    max-height: none;
    overflow-y: visible;
  }
  
  .table-container {
    max-height: none;
  }
}

@media (max-width: 768px) {
  .manage-rewards-container {
    padding: 15px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 15px;
  }
  
  table {
    min-width: 100%;
  }
  
  th, td {
    padding: 8px 10px;
  }
}

@media (max-width: 576px) {
  .manage-rewards-container {
    padding: 10px;
  }
  
  .rewards-form, 
  .rewards-list {
    padding: 15px;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .submit-btn, 
  .cancel-btn {
    width: 100%;
  }
  
  .reward-img {
    width: 40px;
    height: 40px;
  }
}
 /* Center only when there's no cancel button */
 .form-actions:not(:has(.cancel-btn)) {
    justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/MyComponents/MyRewards/ManageRewards.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC,EAAE,yBAAyB;EAChE,iBAAiB;EACjB,eAAe;AACjB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA,iBAAiB;AACjB;EACE,eAAe,EAAE,2BAA2B;EAC5C,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,wBAAmB;EAAnB,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,SAAO;EACP,YAAY,EAAE,+BAA+B;EAC7C,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,qCAAqC;AACvC;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,qCAAqC;EACrC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;AACA;IACI,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;AAEF;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB,EAAE,wBAAwB;AAC5C;AACA;IACI,yBAAyB;IACzB,YAAY;IACZ,gBAAgB;EAClB;AACF;IACI,yBAAyB;EAC3B;;AAEF;EACE,aAAa;EACb,uCAAuC;;AAEzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,iBAAiB;EACjB,qCAAqC;EACrC,iBAAiB;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,yBAAyB;EAC3B;;AAEF,2BAA2B;AAC3B;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;CACC,8CAA8C;CAC9C;IACG,uBAAuB;EACzB","sourcesContent":["/* Main Container */\n.manage-rewards-container {\n  max-width: 1800px;\n  margin: 20px;\n  padding: 20px;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.page-title {\n  color: #103f5f;\n  text-align: center;\n  margin-bottom: 30px;\n  font-size: clamp(1.5rem, 2.5vw, 2rem); /* Responsive font size */\n  font-weight: bold;\n  font-size: 30px;\n}\n\n/* Content Layout */\n.rewards-content {\n  display: flex;\n  gap: 30px;\n  align-items: flex-start;\n}\n\n/* Form Section */\n.rewards-form {\n  flex: 0 1 450px; /* Flexible but max 450px */\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  height: fit-content;\n}\n\n/* Rewards List Section */\n.rewards-list {\n  flex: 1;\n  min-width: 0; /* Fixes flex overflow issues */\n  background: #fff;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  max-height: 88vh;\n  overflow-y: auto;\n}\n\n.rewards-form h3, \n.rewards-list h3 {\n  color: #3498db;\n  margin-top: 0;\n  margin-bottom: 20px;\n  font-size: clamp(1.1rem, 1.5vw, 1.3rem);\n  border-bottom: 1px solid #eee;\n  padding-bottom: 10px;\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: 20px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #555;\n  font-size: clamp(0.9rem, 1.1vw, 1rem);\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"number\"],\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 12px 10px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: clamp(0.9rem, 1.1vw, 1rem);\n  transition: border-color 0.3s;\n}\n\n.form-group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.form-row {\n  display: flex;\n  gap: 15px;\n}\n\n/* File Upload */\n.file-upload {\n  margin-bottom: 10px;\n}\n.cancel-btn {\n    background-color: #e74c3c;\n    color: white;\n  }\n  \n  .cancel-btn:hover {\n    background-color: #c0392b;\n  }\n\n.upload-btn {\n  display: inline-block;\n  padding: 12px 15px;\n  background: #f8f9fa;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.3s;\n  font-size: clamp(0.9rem, 1.1vw, 1rem);\n}\n\n.image-preview img {\n  max-width: 100%;\n  max-height: 150px;\n  border-radius: 4px;\n  border: 1px solid #ddd;\n}\n\n/* Form Actions */\n.form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n\n.submit-btn, .cancel-btn {\n  padding: 12px 20px;\n  font-size: clamp(0.9rem, 1.1vw, 1rem);\n}\n\n/* Table Styles */\n.table-container {\n  overflow-x: auto;\n  max-height: calc(88vh - 100px);\n}\n\ntable {\n  width: 100%;\n  min-width: 600px; /* Minimum table width */\n}\nth {\n    background-color: #3498db;\n    color: white;\n    font-weight: 600;\n  }\ntr:hover {\n    background-color: #f5f5f5;\n  } \n\nth, td {\n  padding: 12px;\n  font-size: clamp(0.85rem, 1vw, 0.95rem);\n  \n}\n\n.reward-img {\n  width: 50px;\n  height: 50px;\n}\n\n/* Action Buttons */\n.edit-btn, .delete-btn {\n  padding: 6px 12px;\n  font-size: clamp(0.8rem, 1vw, 0.9rem);\n  margin-right: 5px;\n    border: none;\n    border-radius: 3px;\n    cursor: pointer;\n}\n.edit-btn {\n    background-color: #2ecc71;\n    color: white;\n  }\n  \n  .edit-btn:hover {\n    background-color: #27ae60;\n  }\n  \n  .delete-btn {\n    background-color: #e74c3c;\n    color: white;\n  }\n  \n  .delete-btn:hover {\n    background-color: #c0392b;\n  }\n\n/* Responsive Breakpoints */\n@media (max-width: 1200px) {\n  .rewards-content {\n    gap: 20px;\n  }\n  \n  .rewards-form {\n    flex-basis: 400px;\n  }\n}\n\n@media (max-width: 992px) {\n  .rewards-content {\n    flex-direction: column;\n  }\n  \n  .rewards-form {\n    flex-basis: auto;\n    width: 100%;\n  }\n  \n  .rewards-list {\n    width: 100%;\n    max-height: none;\n    overflow-y: visible;\n  }\n  \n  .table-container {\n    max-height: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .manage-rewards-container {\n    padding: 15px;\n  }\n  \n  .form-row {\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  table {\n    min-width: 100%;\n  }\n  \n  th, td {\n    padding: 8px 10px;\n  }\n}\n\n@media (max-width: 576px) {\n  .manage-rewards-container {\n    padding: 10px;\n  }\n  \n  .rewards-form, \n  .rewards-list {\n    padding: 15px;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n  \n  .submit-btn, \n  .cancel-btn {\n    width: 100%;\n  }\n  \n  .reward-img {\n    width: 40px;\n    height: 40px;\n  }\n}\n /* Center only when there's no cancel button */\n .form-actions:not(:has(.cancel-btn)) {\n    justify-content: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
